import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';
import { ENV } from '../config';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.guid = this.el.getAttribute('data-guid');
        this.cards = this.el.querySelectorAll('.values_card');
        this.nav = this.el.querySelector('.values_nav');
        this.scale = 0.05;
        this.translateY = ENV.IS_MOBILE ? -5 : -10;

        window.addEventListener('activeValue', (e) => {
            const { target, way, from } = e.detail;

            if (this.guid != target.getAttribute('data-guid')) return;

            if (way == 'enter') {
                let index = parseInt(target.getAttribute('data-index'));

                if (this.nav.querySelector('.-active')) {
                    this.nav.querySelector('.-active').classList.remove('-active');
                }

                if (this.nav.querySelector('[data-index="' + index + '"]')) {
                    this.nav.querySelector('[data-index="' + index + '"]').classList.add('-active');
                }
            }
        });

        window.addEventListener('progressValues', (e) => {
            const { target, progress } = e.detail;

            if (this.guid != target.getAttribute('data-guid')) return;
            
            if (target.classList.contains('is-inview')) {
                let index = parseInt(target.getAttribute('data-index'));
                for (let i = 0; i < index; i++) {
                    let baseScale = 1 - ((index - 1 - i) * this.scale);
                    let baseTranslate = (index - 1 - i) * this.translateY;
                    gsap.set(this.cards[i], {
                        scale: baseScale - (this.scale * progress),
                        y: baseTranslate + (this.translateY * progress),
                    });
                }
            }
        });

        this.sameHeight();
        onWidthResize(() => {
            this.sameHeight()
        });
    }

    sameHeight() {
        let heights = [];

        this.el.style.setProperty('--header-h', this.el.querySelector('.values_header_inner').offsetHeight + 'px');

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].setAttribute('style', '');
        }
    
        for (var i = 0; i < this.cards.length; i++) {
            heights.push(this.cards[i].offsetHeight);
        }

        if (!heights.length) {
            return;
        }

        const tallest = Math.max(...heights);

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].style.height = tallest + "px";
        }

        setTimeout(() => {
            this.call('resize', 'Scroll');
        }, 100);
    }
}
